const { default: Overlay } = await import('@components/overlays')

export default class Menu extends Overlay {
    constructor(menu, button) {
        super(menu, {
            stackable: true,
            mediaQuery: matchMedia('(max-width: 63.938rem)')
        })

        this.button = button

        this.button.addEventListener('click', this.toggle)
        this.element.classList.remove('is-open')
    }

    open() {
        super.open()
        this.element.classList.add('is-open')
        this.button.setAttribute('aria-expanded', true)
    }

    close() {
        super.close()
        this.element.classList.remove('is-open')
        this.button.setAttribute('aria-expanded', false)

        dispatchEvent(new CustomEvent('closesubmenus'))
    }
}